import { useState } from 'react'

import type { ColumnStateMap } from './types'

type Draft = {
  columnsMap: ColumnStateMap
  editedFrom: ColumnStateMap | undefined
}

export const useDraftColumnsMap = (
  committedMap: ColumnStateMap | undefined,
  onCommit: (columnsMap: ColumnStateMap) => void
) => {
  const [draft, setDraft] = useState<Draft>()

  const isDraftPending =
    draft !== undefined && draft.editedFrom === committedMap

  const change = (columnsMap: ColumnStateMap) => {
    setDraft({ columnsMap, editedFrom: committedMap })
    onCommit(columnsMap)
  }

  return {
    columnsMap: isDraftPending ? draft.columnsMap : committedMap,
    change,
    discard: () => setDraft(undefined)
  }
}
